export const GENERAL_URLS = {
  staking: 'https://magicsquare.io/staking',
};
